import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import FeedbackCard from "./FeedbackCard";

const feedbacks = [
  {
    id: 1,
    name: "Odair de Mello Francisco",
    message: "Ótima empresa para adquirir seu automóvel novo.",
    rating: 5,
  },
  {
    id: 2,
    name: "Wagner Lopes",
    message: "Excelente. Comprei meu carro com eles com muita eficiência e um preço ótimo. Recomendo.",
    rating: 5,
  },
  {
    id: 3,
    name: "Antônio José",
    message: "Atendimento muito bom.",
    rating: 5,
  },
  {
    id: 4,
    name: "Gilberto Reis",
    message: "Boa atendimento!",
    rating: 5,
  },

];

const FeedbackCarousel = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="mb-10 text-center text-3xl font-bold text-gray-900">
          O que nossos clientes dizem
        </h2>

        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          className="pb-10"
        >
          {feedbacks.map((feedback) => (
            <SwiperSlide key={feedback.id} className="h-auto">
              <FeedbackCard feedback={feedback} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FeedbackCarousel;
